<template>
    <div>
        <div class="tw-flex tw-flex-col tw-text-xl md:tw-flex-row tw-px-0 md:tw-px-6 tw-pt-6 tw-pb-12 tw-border-0 md:tw-border-t md:tw-border-b md:tw-border-dark-grey">
            <div class="tw-flex tw-flex-col tw-w-full md:tw-w-1/6 tw-border-b tw-border-dark-grey md:tw-border-0">
                <div class="h7 pb-2">INFORMATION</div>
            </div>

            <div class="tw-flex tw-flex-col tw-w-full md:tw-w-5/6 tw-border-b tw-border-dark-grey md:tw-border-0">
                <div class="tw-flex tw-flex-col tw-w-full tw-font-light tw-pb-4">
                    <committee
                        v-for="(committee, index) in committees"
                        :key="index"
                        :modelProp="committee"
                    ></committee>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AppLayoutSidebarNav from "@/Layouts/AppLayoutSidebarNav.vue"
import Committee from "@/Pages/ExternalPages/components/Committee.vue"

export default {
    name: "CommitteeIndex",
    layout: (h, page) => {
        return h(AppLayoutSidebarNav, [
            page
        ])
    },
    components: {
        Committee
    },
    props: {
        'committees': {
            type: Array,
            required: false,
            default: function () {
                return undefined
            }
        },
    },
    data: function () {
        return {

        }
    },
    mounted: function () {
        //
    }
}
</script>
<style scoped>
ol li::marker {
    font-weight: 400;
}
li {
    font-weight: 300;
}

</style>
